import { PERIOD_OPTIONS_MONTHS } from 'mocks/progressFollowUp';

export const getMonthAndYear = (date) => {
  const year = date.slice(0, 4);

  const month = date.slice(5, 7) - 1;

  return `${PERIOD_OPTIONS_MONTHS[month]?.text} ${year}`;
};
